import { isPostHogConfigured, resetPostHog } from '../lib/posthog';

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const logoutCleanup = () => {
  if (isPostHogConfigured) {
    resetPostHog();
  }
  sessionStorage.removeItem('token');
  localStorage.removeItem('idp');
  sessionStorage.removeItem('userInfo');
};

export * from './oktaConfig';
